<script type="text/jsx" lang="jsx">
import { createEditDeltaComponent } from '@/components/edit-delta-factory';
import commonMixin from '@/plans/EVENT_SAAS_CORE/mixin';
import { planTypes } from '@/common/constants';

export default createEditDeltaComponent({
  name: 'EventSaasCoreEditDelta',
  planType: planTypes.EVENT_SAAS_CORE,
  mixin: commonMixin,
  withReplenish: true,
  className: 'opc-ze-core-edit-delta',
  hideConfigDescription: true,
});
</script>

<style lang="scss">
.opc-ze-core-edit-delta {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
